import { AppProviders } from 'providers';
import { RouterProvider } from 'react-router-dom';
import { routes } from 'routers';
import './App.scss';

function App() {
  return (
    <div className='magellan'>
      <AppProviders>
        <RouterProvider router={routes} />
      </AppProviders>
    </div>
  );
}

export default App;
